<div class="unshare-map">
    <div>{{ map?.name }}</div>
    <div *ngIf="sharedUsers">
        <p class="alert alert-green is-active" *ngIf="success">
            <button type="button" class="close" (click)="resetSuccess()"><span
                    aria-hidden="true">&times;</span></button>
            <strong>Success:</strong> Your map has been unshared.
        </p>
        <div class="control-group clearfix">
            <label class="control-label pull-left">Shared:</label>
            <div class="pull-right field">
                <table class="recipientList">
                    <tr *ngIf="sharedUsers.length === 0">
                        <td>None</td>
                    </tr>
                    <tr *ngFor="let user of sharedUsers; index as i">
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td *ngIf="canViewUsers">{{ user.email }}</td>
                        <td>
                            <button type="button" class="btn btn-danger btn-xs" (click)="unshareUser(i)">                                
                                <span class="icon-ui-close-circled"></span>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="control-group clearfix">
            <label class="control-label pull-left">Remove:</label>
            <div class="pull-right field">
                <table class="recipientList">
                    <tr *ngIf="unSharedUsers.length === 0">
                        <td>None</td>
                    </tr>
                    <tr *ngFor="let user of unSharedUsers; index as i">
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td><i title="Undo" class="icon-ui-close-circled" (click)="reshareUser(i)"></i></td>
                    </tr>
                </table>
            </div>
        </div>

    </div>

    <div class="footer text-right">
        <button class="btn btn-primary" (click)="unShare()" [disabled]="unSharedUsers?.length === 0">Unshare</button>
        <button class="btn btn-warning" (click)="close()">Close</button>
    </div>
</div>
